import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/parking/lot/list/v2', Object.assign({}, options, {
    params
  }));

export const getParkingLotList = (params, options) =>
  request.get('/api/parking/lot/selections/v2', Object.assign({}, options, {
    params
  }));

export const getDetail = (params, options) =>
  request.get('/api/parking/lot/detail/v2', Object.assign({}, options, {
    params
  }));

export const beforeDelete = (params, options) =>
  request.post('/api/parking/lot/beforeDelete/v2', qs.stringify(params), options);

export const remove = (params, options) =>
  request.post('/api/parking/lot/remove/v2', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/parking/lot/save/v2', params, options);

export const update = (params, options) => request.post('/api/parking/lot/update/v2', params, options);
